import { IconChevronRight } from '@lib/icons'
import type { FC, PropsWithChildren } from 'react'

import { GtmTriggerName } from '@/constants/gtm'
import { useUpgradePlan } from '../../hooks'
import css from './LimitNotice.module.scss'

export const LimitNotice: FC<PropsWithChildren> = ({ children }) => {
  const openUpgrade = useUpgradePlan()

  const handleUpgradeClick = () =>
    openUpgrade(
      GtmTriggerName.UPGRADE_CRAWLER,
      'Click on Upgrade in the crawler limit notice'
    )

  return (
    <div className={css.container} onClick={handleUpgradeClick}>
      <span className={css.message}>{children}</span>
      <span className={css.link}>
        Upgrade <IconChevronRight />
      </span>
    </div>
  )
}
